import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { IPrompt } from '@/types';
import Time from '../Time';

interface PromptVersionsProps {
  versions: IPrompt[];
}

const PromptVersions = ({ versions }: PromptVersionsProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Version History</CardTitle>
        <CardDescription>View and select previous versions of your prompt</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col flex-1">
        <ScrollArea className="h-[120px]">
          <div className="space-y-2">
            {versions.map((version, index) => (
              <Button key={version.id} className="justify-start w-full text-sm">
                Version {index + 1} - <Time>{version.updated_at}</Time>
              </Button>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default PromptVersions;
